"use strict";

var PAGESIZE = 20;

require("./CompanyPublicationActivity.js");
require("./CompanyPublicationActivityTranslator.js");
require("../../company/comments/CompanyCommentsService.js");

function PublicationActivity(CompanyPublicationActivity, CompanyCommentsService, CompanyPublicationActivityTranslator, $stateParams) {
  return {
    restrict:    "A",
    templateUrl: "partials/company/publications/activity.html",
    scope: {
      source:   "=publicationActivity",
      user:     "=user",
      types:    "=?types"
    },
    link: function($scope) {
      $scope.type       = {type: "comment"};
      $scope.newComment = "";
      $scope.loading    = false;
      $scope.page       = 0;
      $scope.activity   = [];
      $scope.PAGESIZE   = PAGESIZE;

      if($scope.types && $scope.types[0] === 'ACTIVITY'){
        $scope.type.type = '';
        $scope.types = [];
      }
      
      $scope.loadData = function loadData() {
        $scope.loading = true;
        $scope.page    = $scope.page > 0 ? $scope.page : 0;

        /* TODO: That toUpperCase() should be removed
         * and all constants should be uppercase instead.
         */
        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, $scope.type.type ? [$scope.type.type.toUpperCase()] : $scope.types).then(function(activity) {
          $scope.hasNextPage = activity.length > PAGESIZE;
          $scope.loading     = false;
          $scope.activity    = activity.map(CompanyPublicationActivityTranslator);
        });
      };
      
      if( ! $scope.types) {
        $scope.types = [];
      }

      $scope.$on('notification', function(){
        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
        $scope.page = 0;
        $scope.loading = true;
        $scope.loadData();
      });
      
      $scope.setFilter = function setFilter(type) {
        $scope.type.type = type;
        $scope.page      = 0;

        $scope.loadData();
      };

      $scope.addComment = function addComment(newComment, parentId) {
        if( ! newComment) {
          return false;
        }
        var c = {
          activityType: "COMMENT",
          user:         $scope.user,
          type:         "comment",
          pageSize: 10
        };
        
        $scope.loading = true;

        var comment = {
          text: newComment, 
          group: null, 
          objectRelative: {
            id: $stateParams.publicationId
          }, 
          objectRelativeType: 'PUBLICATION', 
          parentId: parentId || null
        };

        CompanyCommentsService.createComment({companyId: $stateParams.companyId}, comment, function(comment) {
          $scope.loading = false;
          c.id = comment.id;
          c.text = comment.text;
          c.createdAt = comment.createdAt;
          c.createdBy = comment.createdBy;
          if(parentId){
            angular.forEach($scope.activity, function(item){
              if(item.id === parentId){
                if(!item.commentChild){
                  item.commentChild = [];
                }
                item.commentChild.push(c);
                if(item.commentChild.length >= item.pageSize){
                  item.pageSize += 10;
                }
              }
            });
          }else{
            $scope.activity.unshift(c);
            $scope.source.prependDataTo("COMMENT", c);
            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
          }
        });

        return false;
      };
      
      $scope.loadData();
    }
  };
}

angular.module("dokiv")
  .directive("publicationActivity", ["CompanyPublicationActivity", "CompanyCommentsService", "CompanyPublicationActivityTranslator", "$stateParams", PublicationActivity]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationActivityDirective.js
// module id = 8
// module chunks = 0